import React from "react";
import { OrderRouteLayer } from "@src/features/order/components";
import { CancelledMapProps } from "./types";

const CancelledMap: React.FC<CancelledMapProps> = (props) => {
  const { order } = props;

  if (!order) return null;

  return <OrderRouteLayer order={order} droneVariant="idleGray" />;
};

export default CancelledMap;
